const detailedMethodsPrint = (secData) => {

      let sectiontext = "<p>";
      secData.sections.forEach((section) => { 
        if (section.figure && section.figure.figureNumber && section.figure.detailedMethods.trim().length !== 0)
        {
          sectiontext += "<p><em>" + section.figure.figureNumber + "</em></p>";
          sectiontext += "<p>" + section.figure.detailedMethods + "</p>";
        }
      });
      sectiontext += "</p></br>";

      let newSection = {
        id: "detailed-methods",
        chapterId: secData.sections[0].chapterId,
        figure: null,
        order: secData.sections[secData.sections.length - 1].order + 1,
        sectionText: [{
          text: sectiontext
        }],
        slug: "detailed-methods",
        title: "Detailed Methods"
      }

      let updatedData = {
        ...secData,
        sections: [...secData.sections, newSection],
      };

  return updatedData;
};

export default detailedMethodsPrint;
